import { useIsAdminUser } from '../../../components/contexts/CurrentUserDetailsContext';
import { useManufacturingModuleVariant } from '../../../featureFlags';

export const useCanEditManufacturingDatabase = (): boolean => {
    const isAdmin = useIsAdminUser();
    const manufacturingModuleVariant = useManufacturingModuleVariant();

    return isAdmin && manufacturingModuleVariant === 'full';
};
